import Vue from 'vue';
import Vuex from 'vuex';
// import UI from '@/store/modules/UI';
import Auth from '@/store/modules/auth';
import Errors from '@/store/modules/errors';
import Terms from '@/store/modules/terms';
import Announcements from '@/store/modules/announcements';
import Maps from '@/store/modules/maps';
import Locations from '@/store/modules/locations';
import LocationTypes from '@/store/modules/location-types';
import Courses from '@/store/modules/courses';
import Categories from '@/store/modules/categories';
import Shops from '@/store/modules/shops';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  modules: {
    Auth,
    Errors,
    Terms,
    Announcements,
    Maps,
    Locations,
    LocationTypes,
    Courses,
    Categories,
    Shops,
  },
  strict: debug,
});

